var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "chat-message",
        { "from-me": _vm.current_user.id == _vm.message.from },
        { "not-from-me": _vm.current_user.id != _vm.message.from }
      ]
    },
    [
      !_vm.lastmessage_at ||
      new Date(_vm.message.created_at.replace(" ", "T")).getDay() !=
        new Date(_vm.lastmessage_at.replace(" ", "T")).getDay()
        ? _c("div", { staticClass: "msg_timebreaker" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm.formatMessageBreaker(_vm.message.created_at)) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: ["msg_outer"] }, [
        _vm.current_user.id != _vm.message.from
          ? _c("div", {
              class: [
                "img_cont_msg",
                { invisible: _vm.message.from == _vm.lastmessage_from }
              ]
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { class: ["msg_wrapper"] },
          [
            _vm._l(_vm.message.attachments, function(attachment) {
              return _c("chat-message-attachment-component", {
                attrs: {
                  attachment: attachment,
                  msgcreated: new Date(_vm.message.created_at).getTime()
                }
              })
            }),
            _vm._v(" "),
            typeof _vm.message.content == "string"
              ? _c(
                  "div",
                  {
                    class: [
                      "msg_container",
                      { send: _vm.current_user.id == _vm.message.from }
                    ]
                  },
                  [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.message.content) }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "msg_time" }, [
                      _vm._v(
                        _vm._s(_vm.formatMessageTime(_vm.message.created_at))
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }